// Client-side overrides for specific project detail pages.
// Keyed by slug. Any fields present here will replace the server values.
// Used by ProjectDetail.jsx.

export const PROJECT_OVERRIDES = {
  "waverly-park-kitchen": {
    title: "Waverly Park Kitchen & Whole-Home Flooring",
    address: "South Tampa",
    category: "renovation",
    beds: null, baths: null, sqft: null,
    __category_label: "RESIDENTIAL",
    description: "Kitchen renovation and full-home flooring for a French Provincial residence in South Tampa. Scope was limited to interior finishes on these two areas of the home.",
    long_description: "The Waverly Park engagement was a targeted, high-craft renovation of the kitchen and full-home flooring in a French Provincial residence in South Tampa. Original heavy walnut cabinetry, dated tile, and yellow-toned finishes were replaced with a light, calm palette: full-height painted shaker cabinetry, statuary quartz waterfall island, integrated appliances, brass and glass open shelving, and continuous cherry hardwood flooring throughout the main level. Scope was intentionally limited to two areas of the home to preserve the surrounding architecture.",
    key_features: [
      "Statuary quartz waterfall island",
      "Full-height painted shaker cabinetry",
      "Integrated appliances, panel-front refrigeration",
      "Brass and glass open shelving",
      "Custom range hood millwork",
      "Continuous cherry hardwood flooring",
      "Undermount farm sink with brushed brass fixtures",
      "Concealed lighting throughout",
    ],
    image_url: "https://customer-assets.emergentagent.com/job_company-site-new/artifacts/gfxrb2yy_After%201.jpeg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_company-site-new/artifacts/gfxrb2yy_After%201.jpeg",
      "https://customer-assets.emergentagent.com/job_company-site-new/artifacts/hc9pzs46_After%202.jpeg",
      "https://customer-assets.emergentagent.com/job_company-site-new/artifacts/q7mitknb_after%203.jpeg",
    ],
    before_images: [
      "https://customer-assets.emergentagent.com/job_company-site-new/artifacts/ylve5xk0_Before%201.webp",
      "https://customer-assets.emergentagent.com/job_company-site-new/artifacts/ek49av7s_Before%202.webp",
    ],
    testimonial_quote: "BCPeabody took our vision for the Waverly Park renovation and made the entire process feel organized and manageable. They transformed our kitchen and coordinated new flooring throughout the home, with careful attention to every finish, transition, and detail. The team communicated clearly, handled questions thoughtfully, and stayed involved from beginning to end. The finished home feels elevated, functional, and completely personal to us. We are thrilled with the result and would trust BCPeabody with another project without hesitation.",
    testimonial_author: "Waverly Park Homeowner",
    testimonial_role: "South Tampa",
  },

  "tampa-va-front-lobby-renovation": {
    title: "VA Front Lobby Renovation, James A. Haley VA Medical Center",
    address: "Tampa, FL",
    category: "federal",
    beds: null, baths: null, sqft: null,
    description: "BCPeabody was the prime contractor for the front lobby renovation of Building 1 at the James A. Haley VA Medical Center in Tampa, one of more than 25 VA task orders the firm completed across Florida.",
    long_description: "The work was sequenced to keep the hospital open to patients and staff throughout, with finishes and life-safety details built to VA healthcare standards.\n\nOwner: U.S. Department of Veterans Affairs · Location: Tampa, FL",
    key_features: null,
  },

  "kissimmee-river-restoration": {
    title: "Kissimmee River Restoration, C-38 Reach 3 Backfill",
    address: "Okeechobee County, FL",
    category: "federal",
    role_attribution: "firm",
    description: "BCPeabody was the prime contractor to the U.S. Army Corps of Engineers for the Canal 38 Reach 3 backfill and Bass embankment degrade in Okeechobee County. The work filled a section of the C-38 canal so the Kissimmee River can return to its natural channel and floodplain, part of one of the largest ecosystem restoration efforts in the country.",
    long_description: "Owner: U.S. Army Corps of Engineers, Jacksonville District · Location: Okeechobee County, FL · Value: $4.8M",
    key_features: null,
    image_url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_company-site-new/artifacts/3bd2d6151a2fed5d_bcpeabody-kissimmee-river-restoration-reach-3-backfill-aerial-01.jpg",
    gallery: [
      "https://customer-assets-gfyr7b9c.emergentagent.net/job_company-site-new/artifacts/3bd2d6151a2fed5d_bcpeabody-kissimmee-river-restoration-reach-3-backfill-aerial-01.jpg",
      "https://customer-assets-gfyr7b9c.emergentagent.net/job_company-site-new/artifacts/b6f2a130e60992c4_bcpeabody-kissimmee-river-restoration-c38-canal-backfill-02.jpg",
      "https://customer-assets-gfyr7b9c.emergentagent.net/job_company-site-new/artifacts/a21cfa90ee467167_bcpeabody-kissimmee-river-restoration-reach-3-aerial-03.jpg",
      "https://customer-assets-gfyr7b9c.emergentagent.net/job_company-site-new/artifacts/527622059d42624b_bcpeabody-kissimmee-river-c38-canal-plug-04.jpg",
    ],
    photo_credit: "Aerial photos: South Florida Water Management District",
    before_images: null,
    beds: null, baths: null, sqft: null,
  },

  "hernando-beach-navigation-channel": {
    title: "Hernando Beach Channel Dredging",
    address: "Hernando Beach, FL",
    description: "BCPeabody completed 3.5 miles of hydraulic and mechanical dredging in the Gulf of Mexico for Hernando County, on schedule and with no change orders. A 5-acre dewatering site met FDEP water clarity standards without chemical additives, resolving a long-running turbidity problem that had stalled the channel for years.",
    long_description: "Owner: Hernando County · Location: Hernando Beach, FL · Value: $8.9M",
    beds: null, baths: null, sqft: null,
  },

  "hair-cuttery-retail-program": {
    title: "Hair Cuttery Build-Out Program",
    long_description: "BC Peabody Construction Services operated as a repeat general contractor for Creative Hairdressers Incorporated and Ratner Companies under a Master Construction Contract, delivering new-store buildouts and remodels for the Hair Cuttery brand across the state of Florida, including Alton Town Center in Palm Beach Gardens, Coconut Point, Dunlawton Square in Port Orange, Lee Vista in Orlando, Merritt Island, Odessa, Old St Augustine, Palencia Commons, Rivercrest, Riverwalk, Salon Cielo Orlando, Seminole, Shoppes of Southdale, Sky Walk, St Augustine Road in Jacksonville, Sunrise Plaza, West Melbourne, Bloomingdale, and additional locations. Each engagement was delivered on aggressive national franchise schedules (typically 55 to 90 days from commencement to turnover) with strict brand-standard finishes, national account vendor coordination, and landlord and property manager compliance.",
    key_features: [
      "Master Construction Contract with Ratner Companies",
      "More than 20 locations delivered across Florida",
      "Aggressive franchise schedules (55 to 90 day turns)",
      "National account vendor and brand-standard coordination",
      "Landlord, property manager, and shopping-center compliance",
      "Storefront signage, graphics, and furniture packages",
      "Weekly progress reporting with photos",
      "Certificate of Occupancy delivery at turnover",
    ],
  },

  "portugues-dam-consulting": {
    title: "Portugues Dam, Ponce, Puerto Rico",
    long_description: "Federal contracting, quality control, safety and environmental support to the prime contractor on one of the Corps of Engineers' largest dam projects in decades.",
    beds: null, baths: null, sqft: null,
  },

  "c-51-improvements-equitable-adjustment": {
    title: "C-51 Improvements, Equitable Adjustment",
    address: "Palm Beach County, FL",
    long_description: "Request for Equitable Adjustment strategy that moved the settlement from a $55K offer to $1.53M.",
    beds: null, baths: null, sqft: null,
  },
};

// Slug aliases: when the current URL slug is a legacy slug, remap to the
// canonical one. ProjectDetail uses this to redirect transparently.
export const PROJECT_SLUG_ALIASES = {
  "3144-west-waverly-park": "waverly-park-kitchen",
  "west-palm-beach-va-main-lobby-renovation": "tampa-va-front-lobby-renovation",
};
